import temaPadrao from "_config/temas/estilo/base";
import { HttpResponse } from "_services/api/HttpResponse";
import { PrimaryButton } from "components/Button/style";
import React, { useState } from "react";
import { Form, InputGroup, Modal } from "react-bootstrap";
import { FunnelFill } from "react-bootstrap-icons";
import { FaPlusCircle, FaTimes, FaTimesCircle } from "react-icons/fa";
import { createGlobalStyle } from "styled-components";
import { CustomInputModalBodyDetalhes } from "./Container";

const BackdropZIndexStyle = createGlobalStyle<{ $zIndex: number }>`
  .modal-backdrop.custom-input-modal-backdrop {
    z-index: ${({ $zIndex }) => $zIndex};
  }
`;

interface CustomInputModalProps {
  label?: string;
  placeholder?: string;
  value?: any[];
  onConfirm: (valores: any[]) => void;
  onClickOk?: (valores: any[]) => Promise<HttpResponse>;
  mensagemErro?: string;
  validar?: boolean;
  sucesso?: boolean;
  disabled?: boolean;
  style?: React.CSSProperties;
  placeholderModal?: string;
  labelItem?: string;
  zIndex?: number;
  naoFecharForaModal?: boolean;
}

export interface IItemComErro {
  item: any;
  mensagem: string;
}

export const CustomInputModal: React.FC<CustomInputModalProps> = ({
  label,
  placeholder,
  value = [],
  onConfirm,
  mensagemErro,
  validar,
  sucesso,
  disabled = false,
  style,
  placeholderModal = "Digite ou cole e pressione Enter",
  onClickOk,
  labelItem,
  zIndex,
  naoFecharForaModal = false,
}) => {
  const [mostrarModal, setMostrarModal] = useState(false);
  const [valoresTemporarios, setValoresTemporarios] = useState<any[]>([]);
  const [itensComErro, setItensComErro] = useState<IItemComErro[] | null>(null);
  const [itensSemErro, setItensSemErro] = useState<any[] | null>(null);
  const [inputTemp, setInputTemp] = useState("");
  const [body, setBody] = useState<"DETALHES" | "INPUT">("INPUT");

  const abrirModal = () => {
    if (!disabled) {
      setValoresTemporarios([...value]);
      setItensComErro(null);
      setItensSemErro(null);
      setBody("INPUT");
      setMostrarModal(true);
    }
  };

  const adicionarValor = (texto: string) => {
    const novos = texto
      .split(/[\n,;\t ]+/)
      .map((v) => v.trim())
      .filter((v) => v.length > 0 && !valoresTemporarios.includes(v));
    setValoresTemporarios((prev) => [...prev, ...novos]);
    setInputTemp("");
  };

  const removerValor = (index: number) => {
    setValoresTemporarios((prev) => prev.filter((_, i) => i !== index));
  };

  const confirmarValores = async () => {
    const itensNaoValidados = obterItensNaoValidados();

    if (onClickOk && itensNaoValidados.length > 0) {
      const { hasErro, data } = await onClickOk(valoresTemporarios);

      if (!hasErro && data && Array.isArray(data)) {
        if (data.length) {
          setItensComErro(data);

          const novosItensSemErro = valoresTemporarios.filter(
            (v) => !data.some((itemErro) => itemErro.item === v)
          );

          setItensSemErro(novosItensSemErro);
        } else {
          setItensComErro([]);
          setItensSemErro(valoresTemporarios);
        }

        return;
      }
    }

    onConfirm(
      Array.isArray(itensComErro)
        ? valoresTemporarios.filter((valor) => {
            return !itensComErro.some((itemErro) => itemErro.item === valor);
          })
        : valoresTemporarios
    );
    setMostrarModal(false);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (["Enter", ","].includes(e.key)) {
      e.preventDefault();
      adicionarValor(inputTemp);
    }
  };

  const obterItensNaoValidados = () => {
    return valoresTemporarios.filter(
      (v) =>
        !(
          (Array.isArray(itensComErro) &&
            itensComErro.some((itemErro) => itemErro.item === v)) ||
          (Array.isArray(itensSemErro) && itensSemErro.includes(v))
        )
    );
  };

  return (
    <>
      <InputGroup
        onClick={abrirModal}
        style={{ cursor: disabled ? "not-allowed" : "pointer", ...style }}
      >
        <div
          className="form-control d-flex flex-nowrap align-items-center"
          style={{
            maxHeight: "36px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            gap: "4px",
            backgroundColor: disabled ? "#e9ecef" : "#fff",
            borderColor:
              mensagemErro && validar
                ? "yellow"
                : sucesso
                ? "green"
                : "#CED4DA",
          }}
        >
          {value.length === 0 && (
            <span style={{ color: "#6c757d", fontSize: 12, lineHeight: 14 }}>
              {placeholder}
            </span>
          )}

          {value.map((v, i) => (
            <span
              key={i}
              className="badge"
              style={{
                padding: "6px 10px",
                borderRadius: "5px",
                marginRight: "4px",
                backgroundColor: "#F5F5F5",
                color: "#7F7F7F",
              }}
            >
              {v}
            </span>
          ))}
        </div>
        <InputGroup.Text
          style={{
            backgroundColor: temaPadrao.colors.project.main,
            border: "none",
            borderColor:
              mensagemErro && validar
                ? "yellow"
                : sucesso
                ? "green"
                : "#CED4DA",
          }}
        >
          <FunnelFill color="#fff" />
        </InputGroup.Text>
        {mensagemErro && (
          <Form.Control.Feedback
            type="invalid"
            style={{
              fontSize: "0.85rem",
              color: temaPadrao.colors.danger.main,
              display: "block",
            }}
          >
            {mensagemErro}
          </Form.Control.Feedback>
        )}
      </InputGroup>

      {zIndex && <BackdropZIndexStyle $zIndex={zIndex - 1} />}

      <Modal
        show={mostrarModal}
        onHide={() => setMostrarModal(false)}
        centered
        size="lg"
        backdrop={naoFecharForaModal ? "static" : undefined}
        keyboard={naoFecharForaModal ? true : undefined}
        style={zIndex ? { zIndex } : undefined}
        backdropClassName={zIndex ? "custom-input-modal-backdrop" : undefined}
      >
        {body === "DETALHES" ? (
          <>
            <CustomInputModalBodyDetalhes
              itens={itensComErro ?? []}
              onVoltar={() => setBody("INPUT")}
              labelItem={labelItem}
            />
          </>
        ) : (
          <>
            <Modal.Header closeButton>
              <Modal.Title>{label ?? "Adicionar valores"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "8px",
                  color: "#7F7F7F",
                }}
              >
                <span
                  onClick={() => {
                    setValoresTemporarios([]);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <FaTimesCircle
                    style={{ marginRight: "4px", fontSize: "14px" }}
                  />
                  Limpar tudo
                </span>
              </div>
              <Form.Group>
                <div
                  style={{
                    padding: "24px",
                    borderRadius: "10px",
                    backgroundColor: "#F5F5F5",
                  }}
                >
                  <div
                    className="justify-content-end align-items-center text-danger"
                    style={{
                      display:
                        Array.isArray(itensComErro) && itensComErro.length
                          ? "flex"
                          : "none",
                    }}
                  >
                    <span
                      className="d-flex align-items-center"
                      style={{ cursor: "pointer" }}
                      onClick={() => setBody("DETALHES")}
                    >
                      <FaPlusCircle
                        style={{ marginRight: "5px", fontSize: "14px" }}
                      />
                      <span>Mais detalhes</span>
                    </span>
                  </div>

                  <div
                    className="form-control d-flex flex-wrap align-items-center"
                    style={{
                      minHeight: "120px",
                      maxHeight: "300px",
                      overflowY: "auto",
                      borderRadius: "5px",
                      gap: "8px",
                    }}
                    onClick={() => {
                      document.getElementById("input-temporario")?.focus();
                    }}
                  >
                    {valoresTemporarios.map((v, i) => {
                      let backgroundColor = "#f5f5f5";
                      let color = "#333333";

                      const temErro =
                        Array.isArray(itensComErro) &&
                        itensComErro.some((itemErro) => itemErro.item === v);

                      const semErro =
                        Array.isArray(itensSemErro) && itensSemErro.includes(v);

                      if (temErro) {
                        backgroundColor = "#f8d7da";
                        color = "#842029";
                      } else if (semErro) {
                        backgroundColor = "#d1e7dd";
                        color = "#0f5132";
                      }

                      return (
                        <span
                          key={i}
                          className="badge d-flex align-items-center"
                          style={{
                            padding: "6px 10px",
                            borderRadius: "12px",
                            gap: "6px",
                            backgroundColor,
                            color,
                            fontWeight: "400",
                          }}
                        >
                          {v}
                          <FaTimes
                            onClick={() => removerValor(i)}
                            style={{
                              fontSize: "8px",
                              color,
                              cursor: "pointer",
                            }}
                          />
                        </span>
                      );
                    })}
                    <input
                      id="input-temporario"
                      className="border-0 flex-grow-1"
                      style={{ minWidth: "150px", outline: "none" }}
                      placeholder={placeholderModal}
                      value={inputTemp}
                      onChange={(e) => setInputTemp(e.target.value)}
                      onKeyDown={handleKeyDown}
                    />
                  </div>
                </div>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <PrimaryButton
                style={{ width: "95px" }}
                outline
                variante="primary"
                onClick={() => setMostrarModal(false)}
                type="button"
              >
                Cancelar
              </PrimaryButton>
              <PrimaryButton
                style={{ width: "103px" }}
                onClick={confirmarValores}
                type="button"
                disabled={false}
              >
                {onClickOk && obterItensNaoValidados().length
                  ? "Validar"
                  : "Continuar"}
              </PrimaryButton>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </>
  );
};
